export const Env = {
    appName: process?.env.REACT_APP_APP_NAME || 'backoffice',
    isDev: process?.env.NODE_ENV === 'development',
    basePath: process?.env.PUBLIC_URL || '',
    appVersion: process?.env.REACT_APP_SPA_VERSION,
};
